import request from '@/utils/request'

//文件列表
export const bidInvitationDocumentList = (data) => {
    return request.get('/api/agent/audit/modifyAuditStatus/bidInvitationDocumentList?bidInvitationDocumentName='+data.bidInvitationDocumentName+"&pageNum="+data.pageNum+"&pageSize="+data.pageSize)
}
//标段列表
export const bidSectionList = (data) => {
    return request.get('/api/agent/audit/modifyAuditStatus/bidSectionList?bidSectionName='+data.bidSectionName+"&pageNum="+data.pageNum+"&pageSize="+data.pageSize)
}
//项目列表
export const bidProjectList = (data) => {
    return request.get('/api/agent/audit/modifyAuditStatus/projectList?projectName='+data.projectName+"&pageNum="+data.pageNum+"&pageSize="+data.pageSize)
}
//文件退回
export const sendBackBidInvitationDocument = (data) => {
    return request.post('/api/agent/audit/modifyAuditStatus/sendBackBidInvitationDocument?bidInvitationDocumentCode='+data.bidInvitationDocumentCode)
}
//标段退回
export const sendBackBidSection = (data) => {
    return request.post('/api/agent/audit/modifyAuditStatus/sendBackBidSection?bidSectionCode='+data.bidSectionCode)
}

//项目退回
export const sendBackProject = (data) => {
  return request.post('/api/agent/audit/modifyAuditStatus/sendBackProject?projectCode='+data.projectCode)
}
//报告列表
export const getEvaluationReportList = (data) => {
  return request.get('/api/agent/audit/modifyAuditStatus/evaluationReport/list?bidSectionName='+data.bidSectionName+"&pageNum="+data.pageNum+"&pageSize="+data.pageSize)
}

//报告退回
export const sendBackEvaluationReport = (data) => {
  return request.post('/api/agent/audit/modifyAuditStatus/evaluationReport/sendBack?bidEvaluationReportGuid='+data.bidEvaluationReportGuid)
}
